import { v4 as uuidv4 } from 'uuid';
import { TEMPLATES } from './templateCatalog';
import { DEFAULT_THEME, THEMES } from './themeRegistry';
import { TEMPLATE_CATEGORIES } from './templateCategories';

function deepClone(value) {
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }

  return JSON.parse(JSON.stringify(value));
}

function cloneSection(section) {
  return {
    id: uuidv4(),
    type: section.type,
    props: deepClone(section.props ?? {}),
    styles: {},
  };
}

export const createInitialContent = (templateId) => {
  const template = TEMPLATES.find((item) => item.id === templateId);
  if (!template) return [];

  return template.sections.map(cloneSection);
};

export const getTemplateById = (id) => TEMPLATES.find((template) => template.id === id);

export const getThemeById = (id) => THEMES[id] || DEFAULT_THEME;

export const getTemplatesByCategory = (category) =>
  TEMPLATES.filter((template) => template.category === category);

export const getTemplateCategories = () => Object.values(TEMPLATE_CATEGORIES);
